export enum CoreItemTypeMask {
  ROUTE = 0,
  ANCHOR = 1 << 0,
  TOGGLE = 1 << 1,
}
